var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkRitual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_1423)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_581_1423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_581_1423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 11.8672C22.6872 13.697 22.2713 15.5012 21.4844 17.1533",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 22.5712C10.5952 22.5712 9.20333 22.2943 7.90466 21.7564C6.60598 21.2184 5.42597 20.43 4.43201 19.4361C2.42462 17.4286 1.29688 14.706 1.29688 11.8672",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2357 21.7529C21.5999 21.7529 22.7058 20.647 22.7058 19.2828C22.7058 17.9186 21.5999 16.8125 20.2357 16.8125C18.8715 16.8125 17.7656 17.9186 17.7656 19.2828C17.7656 20.647 18.8715 21.7529 20.2357 21.7529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2357 21.7529C21.5999 21.7529 22.7058 20.647 22.7058 19.2828C22.7058 17.9186 21.5999 16.8125 20.2357 16.8125C18.8715 16.8125 17.7656 17.9186 17.7656 19.2828C17.7656 20.647 18.8715 21.7529 20.2357 21.7529Z",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98438 7.91716C2.34328 7.02026 2.82547 6.17778 3.41707 5.41406",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59375 2.58244C7.52181 2.04655 8.52729 1.65769 9.57441 1.42969",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0107 7.91716C21.6519 7.02026 21.1697 6.17778 20.5781 5.41406",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4025 2.58244C16.4745 2.04655 15.469 1.65769 14.4219 1.42969",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.71094 13.0759L10.8278 16.2902C12.2945 12.077 13.516 10.2282 16.2824 7.71875",
    stroke: "#e5eaf9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_1423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkRitual);
export default __webpack_public_path__ + "static/media/dark-ritual.5ae9ed3f44fe1a30973f60d3df6151d6.svg";
export { ForwardRef as ReactComponent };